<ng-container *ngIf="loader" class="-align-left ">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Forma za dodavanje nove aktivnosti</h4>
        <button type="button" style="outline: none" (click)="close()" class="close" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form>
            <div class="form-group">
                <label>Tip</label>
                <select (change)="changeType($event)" class="form-control form-select"
                        aria-label="Default select example">
                    <option *ngFor="let item of types" [selected]="item.name==type.name"
                            [value]="item.value">{{item.name}}
                    </option>

                </select>
            </div>
            <div class="form-group" *ngIf="type.name !='Pauza' &&type.name !='Ostalo' &&type.name !='Lični izlazak'">
                <label>Zadatak</label>
                <input class="form-control"
                       type="text"
                       style="caret-color:transparent"
                       placeholder="Izaberi zadatak"
                       matInput
                       (click)="checkTask()"
                       required
                       [(ngModel)]="searchText1"
                       [ngModelOptions]="{standalone: true}"
                       [formControl]="task"
                       [matAutocomplete]="ac">
                <mat-autocomplete #ac="matAutocomplete">
                    <mat-option
                            *ngFor="let t of assignedTasks | searchPipe:searchText1:'title'"
                            [value]="t.title"
                            required="true"
                            (click)="getTask(t)">
                        {{t.title}}
                    </mat-option>
                </mat-autocomplete>
            </div>
            <div class="form-group" *ngIf="type.name !='Pauza' &&type.name !='Ostalo' &&type.name !='Lični izlazak'">
                <label>Projekat</label>
                <app-project-select
                                    [projects]="projects"
                                    [emptyProject]="emptyProject"
                                    [isDisabled]="false"
                                    [dataForEdit]="data"
                                    (outputToParent)="getProjectFromChild($event)"
                                    [form]="form"
                                    [formControl]="projectFormValidate"
                                    required
                ></app-project-select>

            </div>
            <label>Početak</label>
            <div class="row mb-4">

                <div class="col">
                    <div class="input-group">
                        <input class="form-control"
                               placeholder="yyyy-mm-dd"
                               name="dp"
                               [ngModelOptions]="{standalone: true}"
                               [(ngModel)]="activity.startDate"
                               ngbDatepicker #sDate="ngbDatepicker"
                               [formControl]="startDate">
                        <div class="input-group-append ml-2">
                            <button class="btn btn-outline-secondary" type="button"><i
                                    class="fa fa-calendar"></i></button>
                        </div>
                    </div>
                    <div class="mt-2" style="color: red"
                         *ngIf="(form.get('actStartDate').invalid || form.get('actStartTime').invalid )">
                        Unesite datum i vrijeme.
                    </div>
                </div>
                <div class="col">
                    <div class="input-group">
                        <ngb-timepicker class="activity-timepicker" [formControl]="startTime"
                                        [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="activity.startTime"></ngb-timepicker>
                    </div>
                </div>

            </div>


            <label>Kraj</label>
            <div class="row mb-4">

                <div class="col">
                    <div class="input-group">
                        <input class="form-control"
                               placeholder="yyyy-mm-dd"
                               name="dp"
                               [formControl]="endDate"
                               [(ngModel)]="activity.endDate"
                               [ngModelOptions]="{standalone: true}"
                               ngbDatepicker
                               #eDate="ngbDatepicker">
                        <div class="input-group-append ml-2">
                            <button class="btn btn-outline-secondary" type="button"><i
                                    class="fa fa-calendar"></i></button>
                        </div>
                    </div>
                    <div class="mt-2" style="color: red"
                         *ngIf="(form.get('actEndDate').invalid || form.get('actEndTime').invalid )">
                        Unesite datum i vrijeme.
                    </div>
                </div>
                <div class="col">
                    <div class="input-group">
                        <ngb-timepicker class="activity-timepicker" [ngModelOptions]="{standalone: true}"
                                        [formControl]="endTime"
                                        [(ngModel)]="activity.endTime"></ngb-timepicker>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label>Opis aktivnosti</label>
                <textarea class="form-control form-control-sm" [ngModelOptions]="{standalone: true}"
                          [(ngModel)]="activity.description"
                          rows="5"></textarea>
            </div>


        </form>
    </div>
    <div class="modal-footer">
        <div class="col-md-12">
            <button [disabled]="buttonDisabled" (click)="addActivity()"
                    class="btn btn-primary float-right">
                Sačuvaj
            </button>
        </div>
    </div>
</ng-container>












